var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"height":"90vh"},attrs:{"src":_vm.$route.meta.path,"width":"100%","frameBorder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }